import client from './client';

export interface GeocodeResult {
  address: string;
  latitude: number;
  longitude: number;
}

export const geocode = async (q: string): Promise<GeocodeResult[]> => {
  const res = await client.get('/api/v1/maps/geocode', { params: { q } });
  return res.data.results;
};
